/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React, { useEffect, useState } from "react";
// Redux Toolkit
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../store/userSlice";
import { motion } from "framer-motion";
// Material UI components
import CircularProgress from "@mui/material/CircularProgress";
// Custom components
import EmptyListing from "../../../shared-components/crud/listing/EmptyListing";
import OrganizationsListItem from "./OrganizationsListItem";

function OrganizationsList(props) {
  const { organizations } = props;
  const user = useSelector(selectUser);

  if (!organizations) {
    return null;
  }

  if (organizations.length === 0) {
    return (
      <EmptyListing resource="organizations" />
    );
  }

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
      className="flex grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-32 w-full max-h-full my-64 px-24 sm:px-24"
    >
      {Object.keys(organizations).sort().map((key) => (
        organizations[key].map((org) => (
          <OrganizationsListItem key={org.id} organization={org} user={user} />
        ))
      ))}
    </motion.div>
  );
}

export default OrganizationsList;
